export default "__VITE_ASSET__DSW8_zyG__"